import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCalendarItemDetailQueryVariables = Types.Exact<{
  getCalendarItemInput: Types.CalendarItemByUuidInput;
}>;

export type GetCalendarItemDetailQuery = {
  __typename?: "Query";
  getCalendarItem: {
    __typename?: "ClassItem";
    uuid: string;
    type: string;
    templateId: string | null;
    title: string;
    attendanceCap: number;
    spotsAvailable: number | null;
    isAllDay: boolean;
    startDatetime: string;
    endDatetime: string;
    registrationStartOffset: number;
    registrationEndOffset: number;
    registrationLateCancelOffset: number;
    registrationAccess: Types.RegistrationAccess | null;
    price: number;
    tax: { __typename?: "CalendarItemTax"; amount: number | null } | null;
    location: {
      __typename?: "CalendarItemLocation";
      name: string | null;
    } | null;
    attendees: Array<{
      __typename?: "RegistrationByCalendarUuid";
      uuid: string;
      userUuid: string | null;
      customerName: string | null;
      membershipRole: string | null;
      plan: string | null;
      status: string;
      registrationTimestamp: number;
      checkinTimestamp: number | null;
      waitlistUntilTimestamp: number;
      waitlistPriority: number | null;
      primaryImage: string | null;
      checkinUuid: string | null;
      cancelTimestamp: number;
      waitlistConvertedTimestamp: number;
      customerEmail: string | null;
    }> | null;
    mainCoach: {
      __typename?: "Profile";
      userUuid: string;
      firstName: string | null;
      lastName: string | null;
      primaryImage: string | null;
    } | null;
    assistantCoach: {
      __typename?: "Profile";
      userUuid: string;
      firstName: string | null;
      lastName: string | null;
      primaryImage: string | null;
    } | null;
    calendarItemType: {
      __typename?: "CalendarItemType";
      color: string | null;
      isFree: boolean | null;
    } | null;
  };
};

export type CalendarItemAttendeeFragment = {
  __typename?: "RegistrationByCalendarUuid";
  uuid: string;
  userUuid: string | null;
  customerName: string | null;
  membershipRole: string | null;
  plan: string | null;
  status: string;
  registrationTimestamp: number;
  checkinTimestamp: number | null;
  waitlistUntilTimestamp: number;
  waitlistPriority: number | null;
  primaryImage: string | null;
  checkinUuid: string | null;
  cancelTimestamp: number;
  waitlistConvertedTimestamp: number;
  customerEmail: string | null;
};

export type CoachCheckinMutationVariables = Types.Exact<{
  coachCheckinInput: Types.CoachCheckinInput;
}>;

export type CoachCheckinMutation = {
  __typename?: "Mutation";
  coachCheckin: boolean;
};

export type MassSmsCalendarItemMutationVariables = Types.Exact<{
  input: Types.ClassMassSms;
}>;

export type MassSmsCalendarItemMutation = {
  __typename?: "Mutation";
  massSmsCalendarItem: { __typename?: "SuccessResponse"; success: boolean };
};

export type MassEmailCalendarItemMutationVariables = Types.Exact<{
  input: Types.ClassMassEmail;
}>;

export type MassEmailCalendarItemMutation = {
  __typename?: "Mutation";
  massEmailCalendarItem: { __typename?: "SuccessResponse"; success: boolean };
};

export type BulkCheckinMutationVariables = Types.Exact<{
  bulkCheckinInput: Types.BulkCheckinInput;
}>;

export type BulkCheckinMutation = {
  __typename?: "Mutation";
  bulkCheckin: {
    __typename?: "BulkCheckinResult";
    failedCheckins: Array<{
      __typename?: "FailedCheckin";
      reservationId: string;
      reason: string;
    }>;
  };
};

export type CreateReservationMutationVariables = Types.Exact<{
  createReservationInput: Types.ReserveInput;
}>;

export type CreateReservationMutation = {
  __typename?: "Mutation";
  createReservation: { __typename?: "Registration"; uuid: string };
};

export type JoinWaitlistMutationVariables = Types.Exact<{
  joinWaitlistInput: Types.JoinWaitlistInput;
}>;

export type JoinWaitlistMutation = {
  __typename?: "Mutation";
  joinWaitlist: { __typename?: "Registration"; uuid: string };
};

export const CalendarItemAttendeeFragmentDoc = gql`
  fragment CalendarItemAttendee on RegistrationByCalendarUuid {
    uuid
    userUuid
    customerName
    membershipRole
    plan
    status
    registrationTimestamp
    checkinTimestamp
    waitlistUntilTimestamp
    waitlistPriority
    primaryImage
    checkinUuid
    cancelTimestamp
    waitlistConvertedTimestamp
    customerEmail
  }
`;
export const GetCalendarItemDetailDocument = gql`
  query GetCalendarItemDetail($getCalendarItemInput: CalendarItemByUuidInput!) {
    getCalendarItem(getCalendarItemInput: $getCalendarItemInput) {
      uuid
      type
      templateId
      title
      attendanceCap
      spotsAvailable
      isAllDay
      startDatetime
      endDatetime
      registrationStartOffset
      registrationEndOffset
      registrationLateCancelOffset
      registrationAccess
      price
      tax {
        amount
      }
      location {
        name
      }
      attendees {
        ...CalendarItemAttendee
      }
      mainCoach {
        userUuid
        firstName
        lastName
        primaryImage
      }
      assistantCoach {
        userUuid
        firstName
        lastName
        primaryImage
      }
      calendarItemType {
        color
        isFree
      }
    }
  }
  ${CalendarItemAttendeeFragmentDoc}
`;

/**
 * __useGetCalendarItemDetailQuery__
 *
 * To run a query within a React component, call `useGetCalendarItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarItemDetailQuery({
 *   variables: {
 *      getCalendarItemInput: // value for 'getCalendarItemInput'
 *   },
 * });
 */
export function useGetCalendarItemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalendarItemDetailQuery,
    GetCalendarItemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalendarItemDetailQuery,
    GetCalendarItemDetailQueryVariables
  >(GetCalendarItemDetailDocument, options);
}
export function useGetCalendarItemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarItemDetailQuery,
    GetCalendarItemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarItemDetailQuery,
    GetCalendarItemDetailQueryVariables
  >(GetCalendarItemDetailDocument, options);
}
export type GetCalendarItemDetailQueryHookResult = ReturnType<
  typeof useGetCalendarItemDetailQuery
>;
export type GetCalendarItemDetailLazyQueryHookResult = ReturnType<
  typeof useGetCalendarItemDetailLazyQuery
>;
export type GetCalendarItemDetailQueryResult = Apollo.QueryResult<
  GetCalendarItemDetailQuery,
  GetCalendarItemDetailQueryVariables
>;
export const CoachCheckinDocument = gql`
  mutation CoachCheckin($coachCheckinInput: CoachCheckinInput!) {
    coachCheckin(coachCheckinInput: $coachCheckinInput)
  }
`;
export type CoachCheckinMutationFn = Apollo.MutationFunction<
  CoachCheckinMutation,
  CoachCheckinMutationVariables
>;

/**
 * __useCoachCheckinMutation__
 *
 * To run a mutation, you first call `useCoachCheckinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachCheckinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachCheckinMutation, { data, loading, error }] = useCoachCheckinMutation({
 *   variables: {
 *      coachCheckinInput: // value for 'coachCheckinInput'
 *   },
 * });
 */
export function useCoachCheckinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CoachCheckinMutation,
    CoachCheckinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CoachCheckinMutation,
    CoachCheckinMutationVariables
  >(CoachCheckinDocument, options);
}
export type CoachCheckinMutationHookResult = ReturnType<
  typeof useCoachCheckinMutation
>;
export type CoachCheckinMutationResult =
  Apollo.MutationResult<CoachCheckinMutation>;
export type CoachCheckinMutationOptions = Apollo.BaseMutationOptions<
  CoachCheckinMutation,
  CoachCheckinMutationVariables
>;
export const MassSmsCalendarItemDocument = gql`
  mutation MassSmsCalendarItem($input: ClassMassSms!) {
    massSmsCalendarItem(massSmsCalendarInput: $input) {
      success
    }
  }
`;
export type MassSmsCalendarItemMutationFn = Apollo.MutationFunction<
  MassSmsCalendarItemMutation,
  MassSmsCalendarItemMutationVariables
>;

/**
 * __useMassSmsCalendarItemMutation__
 *
 * To run a mutation, you first call `useMassSmsCalendarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassSmsCalendarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massSmsCalendarItemMutation, { data, loading, error }] = useMassSmsCalendarItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassSmsCalendarItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MassSmsCalendarItemMutation,
    MassSmsCalendarItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MassSmsCalendarItemMutation,
    MassSmsCalendarItemMutationVariables
  >(MassSmsCalendarItemDocument, options);
}
export type MassSmsCalendarItemMutationHookResult = ReturnType<
  typeof useMassSmsCalendarItemMutation
>;
export type MassSmsCalendarItemMutationResult =
  Apollo.MutationResult<MassSmsCalendarItemMutation>;
export type MassSmsCalendarItemMutationOptions = Apollo.BaseMutationOptions<
  MassSmsCalendarItemMutation,
  MassSmsCalendarItemMutationVariables
>;
export const MassEmailCalendarItemDocument = gql`
  mutation MassEmailCalendarItem($input: ClassMassEmail!) {
    massEmailCalendarItem(massEmailCalendarInput: $input) {
      success
    }
  }
`;
export type MassEmailCalendarItemMutationFn = Apollo.MutationFunction<
  MassEmailCalendarItemMutation,
  MassEmailCalendarItemMutationVariables
>;

/**
 * __useMassEmailCalendarItemMutation__
 *
 * To run a mutation, you first call `useMassEmailCalendarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassEmailCalendarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massEmailCalendarItemMutation, { data, loading, error }] = useMassEmailCalendarItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassEmailCalendarItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MassEmailCalendarItemMutation,
    MassEmailCalendarItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MassEmailCalendarItemMutation,
    MassEmailCalendarItemMutationVariables
  >(MassEmailCalendarItemDocument, options);
}
export type MassEmailCalendarItemMutationHookResult = ReturnType<
  typeof useMassEmailCalendarItemMutation
>;
export type MassEmailCalendarItemMutationResult =
  Apollo.MutationResult<MassEmailCalendarItemMutation>;
export type MassEmailCalendarItemMutationOptions = Apollo.BaseMutationOptions<
  MassEmailCalendarItemMutation,
  MassEmailCalendarItemMutationVariables
>;
export const BulkCheckinDocument = gql`
  mutation BulkCheckin($bulkCheckinInput: BulkCheckinInput!) {
    bulkCheckin(bulkCheckinInput: $bulkCheckinInput) {
      failedCheckins {
        reservationId
        reason
      }
    }
  }
`;
export type BulkCheckinMutationFn = Apollo.MutationFunction<
  BulkCheckinMutation,
  BulkCheckinMutationVariables
>;

/**
 * __useBulkCheckinMutation__
 *
 * To run a mutation, you first call `useBulkCheckinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCheckinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCheckinMutation, { data, loading, error }] = useBulkCheckinMutation({
 *   variables: {
 *      bulkCheckinInput: // value for 'bulkCheckinInput'
 *   },
 * });
 */
export function useBulkCheckinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkCheckinMutation,
    BulkCheckinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkCheckinMutation, BulkCheckinMutationVariables>(
    BulkCheckinDocument,
    options,
  );
}
export type BulkCheckinMutationHookResult = ReturnType<
  typeof useBulkCheckinMutation
>;
export type BulkCheckinMutationResult =
  Apollo.MutationResult<BulkCheckinMutation>;
export type BulkCheckinMutationOptions = Apollo.BaseMutationOptions<
  BulkCheckinMutation,
  BulkCheckinMutationVariables
>;
export const CreateReservationDocument = gql`
  mutation CreateReservation($createReservationInput: ReserveInput!) {
    createReservation(createReservationInput: $createReservationInput) {
      uuid
    }
  }
`;
export type CreateReservationMutationFn = Apollo.MutationFunction<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      createReservationInput: // value for 'createReservationInput'
 *   },
 * });
 */
export function useCreateReservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReservationMutation,
    CreateReservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReservationMutation,
    CreateReservationMutationVariables
  >(CreateReservationDocument, options);
}
export type CreateReservationMutationHookResult = ReturnType<
  typeof useCreateReservationMutation
>;
export type CreateReservationMutationResult =
  Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;
export const JoinWaitlistDocument = gql`
  mutation JoinWaitlist($joinWaitlistInput: JoinWaitlistInput!) {
    joinWaitlist(joinWaitlistInput: $joinWaitlistInput) {
      uuid
    }
  }
`;
export type JoinWaitlistMutationFn = Apollo.MutationFunction<
  JoinWaitlistMutation,
  JoinWaitlistMutationVariables
>;

/**
 * __useJoinWaitlistMutation__
 *
 * To run a mutation, you first call `useJoinWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinWaitlistMutation, { data, loading, error }] = useJoinWaitlistMutation({
 *   variables: {
 *      joinWaitlistInput: // value for 'joinWaitlistInput'
 *   },
 * });
 */
export function useJoinWaitlistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinWaitlistMutation,
    JoinWaitlistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JoinWaitlistMutation,
    JoinWaitlistMutationVariables
  >(JoinWaitlistDocument, options);
}
export type JoinWaitlistMutationHookResult = ReturnType<
  typeof useJoinWaitlistMutation
>;
export type JoinWaitlistMutationResult =
  Apollo.MutationResult<JoinWaitlistMutation>;
export type JoinWaitlistMutationOptions = Apollo.BaseMutationOptions<
  JoinWaitlistMutation,
  JoinWaitlistMutationVariables
>;
